module.exports = __webpack_public_path__ + "img/16.f650acf6.png";